export default function GetValueFromObject(apiData: any, value: string) {
    const extracted_value = Object(apiData)[value];
    return extracted_value;
}
